"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CxDataTable = void 0;
const mantine_datatable_1 = require("mantine-datatable");
const React = __importStar(require("react"));
const core_1 = require("@mantine/core");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_1 = require("react");
const hooks_1 = require("@mantine/hooks");
const defaultProps = {
    dataTablePageSizes: [10, 25, 50, 100],
    pageSize: 10,
    //page: 1,
    paginationColor: "ascentis",
    tableFontSize: "md",
    tableHorizontalSpacing: "xs",
    tableMinHeight: 200,
    noRecordsText: "No records to show",
    tableHeight: 400,
    searchBarWidth: 600
};
function renderActions(record, contextMenus) {
    //TODO: If more than 3 icons do something
    const actions = contextMenus.items(record).map((item, index) => React.createElement(core_1.Tooltip, { key: index, label: item.title },
        React.createElement(core_1.ThemeIcon, { color: item.iconColor, onClick: item.onClick },
            React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: item.icon ? item.icon : free_solid_svg_icons_1.faMagnifyingGlass, size: "xs" }))));
    return React.createElement(React.Fragment, null,
        React.createElement(core_1.Group, { px: 0, position: "left", spacing: "xs" }, actions));
}
function CxDataTable(inputProps) {
    // Updated: This Table should just thinly wrap Mantine DataTable, search etc should be at the shell level.
    const props = (0, core_1.useComponentDefaultProps)("CxDataTable", defaultProps, inputProps);
    const [sortStatus, setSortStatus] = (0, react_1.useState)({
        columnAccessor: props.sortBy,
        direction: props.isDesc ? "desc" : "asc"
    });
    const { ref, width, height } = (0, hooks_1.useElementSize)();
    const updatedColumns = props.columns.slice();
    if (props.rowActions) {
        console.log("Props.RowActions", width);
        const actionColumn = {
            accessor: props.rowActions.accessor ? props.rowActions.accessor : "actions",
            title: props.rowActions.title ? props.rowActions.title : "",
            render: (record) => renderActions(record, props.rowActions),
            textAlignment: "right",
            width: 120
            //ellipsis: true
        };
        //Add action to first column
        updatedColumns.splice(0, 0, actionColumn);
    }
    (0, react_1.useEffect)(() => {
        //console.log('sortStatus?')
        //console.log(sortStatus)
        if (props.setSortBy && props.setIsDesc) {
            props.setSortBy(sortStatus.columnAccessor);
            props.setIsDesc(sortStatus.direction == "desc");
        }
    }, [sortStatus]);
    (0, react_1.useEffect)(() => {
        if (props.setPage) {
            props.setPage(1);
        }
    }, [props.pageSize]);
    return (React.createElement(React.Fragment, null,
        React.createElement(core_1.Box, { sx: { height: props.tableHeight }, ref: ref },
            React.createElement(mantine_datatable_1.DataTable, { withBorder: true, withColumnBorders: true, striped: true, highlightOnHover: true, fontSize: props.tableFontSize, horizontalSpacing: props.tableHorizontalSpacing, minHeight: props.tableMinHeight, noRecordsText: props.noRecordsText, 
                //Pagination
                page: props.page, onPageChange: props.setPage, totalRecords: props.totalRecords, recordsPerPage: props.pageSize, 
                //Page selector
                recordsPerPageOptions: props.dataTablePageSizes, onRecordsPerPageChange: props.setPageSize, 
                //rowContextMenu={props.actions}
                recordsPerPageLabel: props.recordsPerPageLabel, paginationText: props.paginationText, paginationColor: props.paginationColor, sortStatus: sortStatus, onSortStatusChange: setSortStatus, records: props.records, 
                //columns={props.columns}
                columns: updatedColumns, fetching: props.isFetching }))));
}
exports.CxDataTable = CxDataTable;
//# sourceMappingURL=CxDataTable.js.map